import {useCallback, useEffect, useRef, useState} from "react";

export const DEFAULT_SEARCH_DEBOUNCE_MS = 500;

export type DebouncedSearch = {
    input: string;
    debounced: string;
    setInput: (value: string) => void;
    clear: () => void;
};


export function useDebouncedSearch(delay: number = DEFAULT_SEARCH_DEBOUNCE_MS, initialValue = ''): DebouncedSearch {
    const [input, setInputState] = useState(initialValue);
    const [debounced, setDebounced] = useState(initialValue.trim());
    const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    // Drop a pending update if the component unmounts mid-pause
    useEffect(() => () => clearTimeout(timerRef.current), []);

    const setInput = useCallback((value: string) => {
        setInputState(value);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setDebounced(value.trim()), delay);
    }, [delay]);

    const clear = useCallback(() => {
        clearTimeout(timerRef.current);
        setInputState('');
        setDebounced('');
    }, []);

    return {input, debounced, setInput, clear};
}
